// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__8LbnB","content":"styles_content__1-sVw","selectAll":"styles_selectAll__1BOSx"};